import script from "./create_template_data.vue?vue&type=script&setup=true&lang=js"
export * from "./create_template_data.vue?vue&type=script&setup=true&lang=js"

import "./create_template_data.vue?vue&type=style&index=0&id=680cecc4&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-680cecc4"]])

export default __exports__